import React, { useEffect, useState } from "react";

function MobileCatalogFilterCbItem({
  item,
  onClickFilterItem,
  isApplied = false,
  cbType = "normal",
}) {
  const data_val = JSON.stringify({
    choice_type: item?.choice_type,
    title: item?.title,
    items: [
      {
        id: item?.id,
        name: item?.name,
        url_slug: item?.url_slug,
      },
    ],
  });

  const [isCbChecked, setIsCbChecked] = useState(false);

  useEffect(() => {
    setIsCbChecked(isApplied);
  }, [isApplied]);

  const handleCbChange = (data, isChecked) => {
    let item_data = JSON.parse(data) || {};
    setIsCbChecked(isChecked);
    onClickFilterItem(item_data, isChecked);
  };
  return (
    <div className="form-check filter-check">
      <input
        className="form-check-input"
        type="checkbox"
        value=""
        data-val={data_val}
        checked={isCbChecked}
        onChange={(e) =>
          handleCbChange(e.target.getAttribute("data-val"), e.target.checked)
        }
        id={"cbitem-" + item?.url_slug}
      />
      <label
        className={`form-check-label text-left text-black ${
          cbType.toString().toLowerCase() === "filter_color"
            ? "color-label"
            : ""
        }`}
        htmlFor={"cbitem-" + item?.url_slug}
      >
        {cbType.toString().toLowerCase() === "price" && (
          <img
            src="../assets/images/icons/rupee.png"
            className="rupee-sign"
            alt=""
          />
        )}
        {cbType.toString().toLowerCase() === "filter_color" && (
          <span
            className={
              item?.name.toString().toLowerCase().replace(/\s+/g, "-") || ""
            }
          >
            &nbsp;&nbsp;
          </span>
        )}
        {item?.name}
      </label>
    </div>
  );
}

export default MobileCatalogFilterCbItem;
